<template>
  <div class="CollapsibleTree">
    <div
      :class="`columns CollapsibleTree-header ${
        option.children && option.children.length !== 0 ? 'clickable' : ''
      } ${option.children && option.children.length !== 0 && displayChildren ? 'mb-1' : ''}`"
      @click="displayChildren = !displayChildren"
      @keyup.enter="displayChildren = !displayChildren"
    >
      <div class="CollapsibleTree-header-infos columns column is-11">
        <div class="column is-1 sizeWidthChildren">
          <slot
            name="openSubMenu"
            :display-children="displayChildren"
          >
            <FontAwesomeIcon
              v-if="option.children && option.children.length !== 0"
              :icon="displayChildren ? 'caret-down' : 'caret-right'"
              aria-hidden="false"
              class="clickable mr-3"
              :tabindex="option.children && option.children.length !== 0 ? 0 : -1"
            />
          </slot>
        </div>
        <div :class="option && Object.keys(tags || {}).length ? 'column is-7' : 'column is-8'">
          <slot
            name="label"
            :option="option"
          >
            <p class="TitleCardWithLimitLengthInCollapsibleTree">
              <TitleCardWithLimitLength
                :limit="option && Object.keys(tags || {}).length ? 80 : 95"
                :local-name="option.localName || option.dataNameLocal || option.id"
                position="is-right"
              />
            </p>
          </slot>
        </div>
        <div
          v-if="option.dataDescriptionLocal"
          class="column is-1 sizeWidthDescription"
        >
          <slot
            name="description"
            :option="option"
          >
            <sup class="iconSup">
              <b-tooltip
                :label="
                  $t('applications.description') + option.dataDescriptionLocal
                "
                position="is-right"
                size="is-large"
                multilined
                animated
                :append-to-body="true"
              >
                <b-icon
                  icon="info-circle"
                  type="is-dark"
                />
              </b-tooltip>
            </sup>
          </slot>
        </div>
        <div
          v-if="option && Object.keys(tags || {}).length !== 0"
          class="column is-1 tooltipTagList"
        >
          <slot
            name="tags"
            :option="option"
            :tags="tags"
          >
            <sup class="iconSup">
              <b-tooltip
                type="is-light"
                position="is-right"
                size="is-large"
                multilined
                animated
                :append-to-body="true"
              >
                <b-icon
                  icon="tags"
                  type="is-primary"
                />
                <template #content>
                  <p>{{ $t("tags.tag") + ' :' }}</p>
                  <TagsInfos
                    :info-parent="option"
                    :tags-column="tags"
                    :tags-menu="true"
                  />
                </template>
              </b-tooltip>
            </sup>
          </slot>
        </div>
        <div
          v-if="lineCount || refFile"
          :style="`transform:translate(${level * 50}px);`"
          class="column is-2"
        >
          <slot
            name="synthesisDetail"
            :line-count="lineCount"
            :on-click-label-synthesis-detail-cb="onClickLabelSynthesisDetailCb"
            :option="option"
            :ref-file="refFile"
          >
            <!-- TODO: Reste a voir avec les spec de la synthèse si on le rend visible ici ou via un click sur une icon -->
            <!-- <div
              v-if="option.synthesisMinMax"
              :class="
                option.synthesisMinMax && onClickLabelSynthesisDetailCb
                  ? 'tile synthesis-details link column is-four-fifths'
                  : 'tile synthesis-details column is-full'
              "
              @click="
                (event) =>
                  option.synthesisMinMax &&
                  onClickLabelSynthesisDetailCb &&
                  onClickLabelSynthesisDetailCb(event, option)
              "
            >
              <span class="synthesis-infos has-text-info-dark column is-full">
                <b-field v-show="false">
                  {{
                    new Date(option.synthesisMinMax[0]).toLocaleDateString("fr") +
                      " - " +
                      new Date(option.synthesisMinMax[1]).toLocaleDateString("fr")
                  }}
                </b-field>
                <availiblity-chart
                  :id="option.id"
                  :minmax="option.synthesis.minmax"
                  :ranges="option.synthesis.ranges"
                  :show-dates="false"
                  class="tile availiblity-chart"
                />
              </span>
            </div>-->
            <!--
              Le spinner d'upload est rendu inline avec le compteur de
              lignes ( ou le nom du fichier en cours d'upload ) pour qu'il
              reste visible : sans flex , il était rendu sur une nouvelle
              ligne sous "840 lignes" et finissait coupé visuellement par
              le pied de carte.
            -->
            <div class="lineCount-row">
              <span
                v-if="lineCount"
                :class="lineCount ? 'lineCount' : 'lineCount has-text-danger'"
              >
                {{ $t("validation.count-line", lineCount) }}
              </span>
              <span
                v-else-if="refFile"
                class="file-name"
              >
                {{ refFile.name }}
              </span>
              <LoadingAnimate
                v-if="isLoading"
                :size="'is-small'"
                class="inline-spinner"
              />
            </div>
          </slot>
        </div>
      </div>
      <div class="CollapsibleTree-buttons columns column is-1">
        <div class="column is-6">
          <slot
            name="upload"
            :on-upload-cb="onUploadCb"
            :option="option"
            :ref-file="refFile"
            :repository-redirect="repositoryRedirect"
          >
            <div v-if="onUploadCb && option.canUpload">
              <b-upload
                v-model="refFile"
                accept=".csv"
                expanded
                rounded
                class="button is-dark is-outlined is-small"
                @update:model-value="() => onUploadCb(option.id, refFile) && showChildren()"
              >
                <span>
                  <b-icon icon="upload" />
                </span>
              </b-upload>
            </div>
            <div v-else>
              <b-button
                :disabled="!(option.canUpload || option.canPublish || option.canDelete)"
                expanded
                rounded
                :type="
                  option.canUpload || option.canPublish || option.canDelete
                    ? 'is-dark'
                    : 'is-light'
                "
                class="is-rounded is-dark is-outlined"
                size="is-small"
                @click="repositoryRedirect(option.id)"
              >
                <span
                  :disabled="!(option.canUpload || option.canPublish || option.canDelete)"
                  class="archive"
                >
                  <b-icon icon="archive" />
                </span>
              </b-button>
            </div>
          </slot>
        </div>
        <div class="column is-6">
          <slot
            name="buttons"
            :buttons="buttons"
            :option="option"
          >
            <div
              v-for="button in buttons"
              :key="button.id"
            >
              <b-button
                :disabled="button.disabled"
                expanded
                rounded
                :icon-left="button.iconName"
                type="is-primary"
                class="is-rounded"
                size="is-small"
                @click="button.clickCb(option.id)"
              />
            </div>
          </slot>
        </div>
      </div>
    </div>
    <slot
      :display-children="displayChildren"
      :option="option"
    >
      <CollapsibleTree
        v-for="child in option.children"
        :key="child.id"
        class="children"
        :application-title="applicationTitle"
        :buttons="buildButton ? buildButton(child) : buttons"
        :build-button="buildButton"
        :class="displayChildren ? '' : 'hide'"
        :level="level + 1"
        :line-count="lineCountSynthesis(referenceSynthesis, child)"
        :on-click-label-cb="onClickLabelCb"
        :on-upload-cb="onUploadCb"
        :option="child"
        :radio-name="radioName"
        :reference-synthesis="referenceSynthesis"
        :with-radios="withRadios"
        @option-checked="onInnerOptionChecked"
      />
    </slot>
  </div>
</template>

<script lang="ts">
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
// TODO: AvailiblityChart à réintégrer quand la synthèse sera implémentée (CollapsibleTree.vue:94)
import LoadingAnimate from "@/components/common/LoadingAnimate.vue";
import { lineCountSynthesis } from "@/composable/application/synthesis";
import { watch } from "vue";
import useBoolean from "@/composable/components/boolean";
import TagsInfos from "@/components/common/TagsInfos.vue";
import TitleCardWithLimitLength from "@/components/common/TitleCardWithLimitLength.vue";
import { BIcon, BTooltip, BUpload } from "buefy";
import "@/style/components/CollapsibleTree.scss";

export default {
  name: "CollapsibleTree",
  components: {
    BTooltip,
    BIcon, BUpload, TitleCardWithLimitLength, TagsInfos, LoadingAnimate, FontAwesomeIcon },
  props: {
    buildButton: Function,
    applicationName: String,
    canUpload: {
      type: Boolean,
      default: true,
    },
    option: Object,
    level: {
      type: Number,
      default: 0,
    },
    showEmpty: {
      value: {
        type: Boolean,
        default: false,
      },
    },
    tags: {
      type: Object,
    },
    testValue: {
      type: Object,
    },
    referenceSynthesis: Array,
    onClickLabelCb: Function,
    onClickLabelSynthesisDetailCb: Function,
    onUploadCb: Function,
    buttons: Array,
    withRadios: {
      type: Boolean,
      default: false,
    },
    radioName: Object,
    repository: Object,
    repositoryRedirect: Function,
    lineCount: {
      type: Number,
      default: 0,
    },
    isLoading: Boolean,
    isUploading: Boolean,
    applicationTitle: {
      type: String,
    },
  },
  setup(_props, { emit }) {
    let innerOptionChecked = null;
    let refFile = null;
    const { refBoolean: displayChildren, doChangeBoolean: changeDisplayChildren } = useBoolean();
    watch(
      () => innerOptionChecked,
      (value) => {
        emit("optionChecked", value);
      },
    );

    function onInnerOptionChecked(value: any) {
      emit("optionChecked", value);
    }

    function showChildren() {
      changeDisplayChildren(true);
    }

    return {
      onInnerOptionChecked,
      showChildren,
      lineCountSynthesis,
      displayChildren,
      refFile,
      innerOptionChecked,
    };
  },
  computed: {
    length() {
      return length;
    },
  },
};
</script>

<style scoped>
/*
 * Compteur de lignes ( "840 lignes" ) et spinner d'upload alignés
 * horizontalement plutôt qu'empilés verticalement : le spinner restait
 * masqué par le pied de carte quand il s'affichait sous le compteur.
 */
.lineCount-row {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: nowrap;
}
.inline-spinner {
  flex: 0 0 auto;
}
</style>
